<template>
	<div>
		<div class="stu-msg-box">
			<div class="pic-box head-pic">
				<van-image v-if="stuMsg.avatar" width="2rem" height="2rem" fit="cover" :src="stuMsg.avatar" />
			</div>
			<div class="stu-msg-item">
				<p v-text="stuMsg.name"></p>
				<p v-text="stuMsg.classGroud"></p>
			</div>
		</div>
		<div v-if="userType == 1">
			<p class="no-margin title-p title-margin-top gray-background">班主任</p>
			<van-cell v-for="(it, index) in teachersList" :key="index">
				<div class="list-item">
					<p class="no-margin" v-text="it.teacherName"></p>
					<p class="no-margin" v-text="it.telephone"></p>
				</div>
			</van-cell>
			<div class="no-data" v-if="teachersList.length == 0">
				<img src="../../assets/no_data.svg" alt="">
				<p class="color-gray">当前没有数据</p>
			</div>

			<p class="no-margin title-p gray-background">家长信息</p>
			<van-cell v-for="(it, index) in parentsList" :key="index">
				<div class="list-item">
					<p class="no-margin item-width aline-left" v-text="it.parentName"></p>
					<p class="no-margin item-width" v-text="it.relationShip"></p>
					<p class="no-margin item-width" v-text="it.parentTelephone"></p>
				</div>
			</van-cell>
			<div class="no-data" v-if="parentsList.length == 0">
				<img src="../../assets/no_data.svg" alt="">
				<p class="color-gray">当前没有数据</p>
			</div>
		</div>

		<p class="no-margin title-p gray-background">体温数据</p>
		<van-cell is-link @click="timeSelecterShow=true">
			<div class="list-item">
				<p class="select-time">月份</p>
				<p class="select-time color-gray" v-text="selectDate"></p>
			</div>
		</van-cell>
		<div class="bg-div"></div>
		<van-cell v-for="(it, index) in temps" :key="index">
			<div class="list-item">
				<p class="select-time little-size more-width" v-text="it.date"></p>
				<p class="select-time little-size" v-text="stuMsg.name"></p>
				<p class="select-time little-size" v-if="it.peroids[0] != undefined" v-text="it.peroids[0].userTemp.tempF" :class="{'color-red': it.peroids[0].userTemp.tempF < minTemp || it.peroids[0].userTemp.tempF > maxTemp}"></p>
				<p class="select-time little-size color-red" v-if="it.peroids[0] == undefined">未上报</p>
				<p class="select-time little-size" v-if="it.peroids[1] != undefined" v-text="it.peroids[1].userTemp.tempF" :class="{'color-red': it.peroids[1].userTemp.tempF < minTemp || it.peroids[1].userTemp.tempF > maxTemp}"></p>
				<p class="select-time little-size color-red" v-if="it.peroids[1] == undefined">未上报</p>
				<p class="select-time little-size" v-if="it.peroids[2] != undefined" v-text="it.peroids[2].userTemp.tempF" :class="{'color-red': it.peroids[2].userTemp.tempF < minTemp || it.peroids[2].userTemp.tempF > maxTemp}"></p>
				<p class="select-time little-size color-red" v-if="it.peroids[2] == undefined">未上报</p>
			</div>
		</van-cell>


		<div class="no-data" v-if="temps.length == 0">
			<img src="../../assets/no_data.svg" alt="">
			<p class="color-gray">当前没有数据</p>
		</div>
		<van-popup position="bottom" v-model="timeSelecterShow">
			<van-datetime-picker v-model="currentDate" type="year-month" :min-date="minDate" :max-date="maxDate" @confirm="timeConfirm" />
		</van-popup>
		<bottom-tab></bottom-tab>
	</div>
</template>

<script>
	import Vue from 'vue';
	import api from '../../http/api.js'

	import {
		Toast,
		Cell,
		DatetimePicker,
		Popup
	} from 'vant';

	Vue.use(Toast);
	Vue.use(Popup);
	Vue.use(Cell)
	Vue.use(DatetimePicker)

	export default {
		data() {
			return {
				stuId: '',
				stuMsg: { // 基本信息
					avatar: '',
					name: '',
					classGroud: ''
				},
				timeSelecterShow: false,
				userType: '', //1：学生  2：教职工
				parentsList: [], // 家长列表
				teachersList: [], // 班主任列表
				minDate: new Date(2020, 0, 1),
				maxDate: new Date(2030, 10, 1),
				currentDate: new Date(),
				selectDate: this.formatDate(new Date(), 'yyyy/MM'), // 选择的时间
				classessList: [], //班次列表
				temps: [], //体温数据
				minTemp: localStorage.getItem('minTemp'),
				maxTemp: localStorage.getItem('maxTemp'),
				schoolId: localStorage.getItem('scId')
			}
		},
		methods: {
			pageInit() {
				this.stuId = window.localStorage.getItem('selectStuId')
				// window.localStorage.removeItem('selectStuId')
				this.getUserParents(); //获取用户对应的关联人
				this.getUserMsg(); // 获取用户信息
				this.getClasses(); // 获取班次
			},
			timeConfirm(value) {
				this.selectDate = this.formatDate(value, 'yyyy/MM')
				this.timeSelecterShow = false
				this.stringfyRes()
			},
			getUserParents() {
				api.getUserParents(this.stuId).then(res => {
					if (res.data.code == 200) {
						for (let i = 0; i < res.data.data.parents.length; i++) {
							this.parentsList.push(res.data.data.parents[i])
						}
						for (let i = 0; i < res.data.data.teachers.length; i++) {
							this.teachersList.push(res.data.data.teachers[i])
						}
					} else {
						Toast('获取用户关联人失败：' + res.data.msg)
					}
				})
			},
			getUserMsg() {
				api.getUserInfo(this.stuId).then(res => {
					// console.log(res);
					if (res.data.code == 200) {
						for (let i = 0; i < res.data.data.roles.length; i++) {
							if (res.data.data.roles[i].id == 5) {
								// 角色是学生
								this.userType = 1
							} else {
								this.userType = 2
							}
						}
						this.stuMsg.avatar = res.data.data.avatar
						this.stuMsg.name = res.data.data.name
						this.stuMsg.classGroud = res.data.data.depts[0].name
						// console.log(this.stuMsg);
					} else {
						Toast('获取用户信息失败：' + res.data.msg)
					}
				})
			},
			getClasses() {
				let key = "school_" + window.localStorage.getItem("scId") + "_TempInfo";
				api.loadAreaTempInfo(key).then(res => {
					if (res.data.code == 200) {
						this.classessList = JSON.parse(res.data.data.configValue);
						this.stringfyRes()
					} else {
						Toast('获取班次列表失败')
					}
				})
			},
			stringfyRes: function () {
				this.temps = [];
				let config = this.classessList;

				let str = this.selectDate.replace('/', '-')
				let selectMonth = new Date(str)
				let year = selectMonth.getFullYear();
				let month = selectMonth.getMonth()
				let dayCount = this.mGetDate(year, month + 1)
				let startDate = this.formatDate(new Date(year, month, 1), 'yyyy/MM/dd hh:mm:ss')
				let endDate = this.formatDate(new Date(year, month, dayCount), 'yyyy/MM/dd hh:mm:ss')

				let page = this
				api.loadUserTempReport(this.stuId, this.schoolId, config.scheduleList, 'all', startDate, endDate).then(res => {
					let data = res.data.data
					let days = this.buildEmptyDays(year, month, config.scheduleList)
					days.forEach(day => {
						for (let i = 0; i < config.scheduleList.length; i++) {
							day.peroids.push(page.findDate2(data, day.date, config.scheduleList[i].startTime + ":00"))
						}
					})
					for (let i = 0; i < days.length; i++) {
						this.temps.push(days[i])
					}
				})
			},

			findDate2(data, day, start) {
				let item = data.find(item => {
					// console.log(item.date + ' --> ' + day)
					return item.date == day
				})

				if (item) {
					let per = item.peroids.find(p => {
						return p.start == start
					})

					if (per) {
						return per
					}
				}
			},

			buildEmptyDays(year, month) {
				let dayCount = this.mGetDate(year, month + 1)
				let targetMonth = new Date(year, month)
				let today = new Date()
				let thisMonth = new Date(today.getFullYear(), today.getMonth())
				if (targetMonth.getTime() > thisMonth.getTime()) {
					//超过当前时间
					return []
				} else if (targetMonth.getTime() == thisMonth.getTime()) {
					//是当前月
					dayCount = today.getDate()
				}
				let result = []
				for (let i = 0; i < dayCount; i++) {
					result.push({
						date: this.formatDate(new Date(year, month, i + 1), 'yyyy-MM-dd'),
						peroids: []
					})
				}

				return result
			},

			mGetDate(year, month) {
				var d = new Date(year, month, 0);
				return d.getDate();
			},



			formatDate(date, fmt) {
				date = date == undefined ? new Date() : date;
				date = typeof date == "number" ? new Date(date) : date;
				fmt = fmt || "yyyy-MM-dd HH:mm:ss";
				let obj = {
					y: date.getFullYear(), // 年份，注意必须用getFullYear
					M: date.getMonth() + 1, // 月份，注意是从0-11
					d: date.getDate(), // 日期
					q: Math.floor((date.getMonth() + 3) / 3), // 季度
					w: date.getDay(), // 星期，注意是0-6
					H: date.getHours(), // 24小时制
					h: date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, // 12小时制
					m: date.getMinutes(), // 分钟
					s: date.getSeconds(), // 秒
					S: date.getMilliseconds() // 毫秒
				};
				let week = ["天", "一", "二", "三", "四", "五", "六"];
				for (let i in obj) {
					fmt = fmt.replace(new RegExp(i + "+", "g"), function (m) {
						let val = obj[i] + "";
						if (i == "w") return (m.length > 2 ? "星期" : "周") + week[val];
						for (let j = 0, len = val.length; j < m.length - len; j++)
							val = "0" + val;
						return m.length == 1 ? val : val.substring(val.length - m.length);
					});
				}
				return fmt;
			}
		},
		mounted() {
			this.pageInit()
		}
	}
</script>

<style scoped>
	.stu-msg-box {
		display: flex;
		padding-left: 10px;
	}

	.pic-box {
		width: 2rem;
		height: 2rem;
		background-image: url("../../assets/avatar.jpg");
		background-repeat: no-repeat;
		background-size: 2rem 2rem;
	}

	.pic-box img {
		width: 100%;
	}

	.stu-msg-item {
		padding: 0 20px;
		text-align: left;
	}

	.stu-msg-item p:nth-child(1) {
		font-size: 0.5rem;
		margin: 0;
		line-height: 1rem;
	}

	.stu-msg-item p:nth-child(2) {
		margin: 0;
		line-height: 1rem;
	}

	.no-margin {
		line-height: 0.5rem;
		padding-left: 10px;
	}

	.title-p {
		line-height: 1rem;
	}

	.title-margin-top {
		margin-top: 10px;
	}

	.list-item {
		display: flex;
		justify-content: space-between;
		line-height: 1rem;
	}

	.item-width {
		width: 33%;
		text-align: center;
	}

	.aline-left {
		width: 25%;
		text-align: left;
	}

	.select-time {
		margin: 0;
	}

	.van-cell__right-icon {
		line-height: 1rem;
	}

	.bg-div {
		background: rgb(245, 246, 249);
		height: 10px;
	}

	.little-size {
		font-size: 0.2rem;
		text-align: center;
		width: 20%;
		line-height: 30px;
	}

	.more-width {
		width: 25%;
	}

	.color-red {
		color: red;
	}
</style>
e>